module.exports = __webpack_public_path__ + "img/OurLocation.07491800.png";